import React, { useEffect, useState, useCallback } from "react";
import styled from "styled-components";
import Header from "./Header";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import trashcan from "./images/trash.png"
import { jwtDecode } from "jwt-decode";
import Promos from "./Promos";

const preciseRound = (number, precision = 2) => {
  const factor = Math.pow(10, precision);
  return Math.floor((number) * factor) / factor; 
};

const CartPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const [errors, setErrors] = useState([]);
  const [formData, setFormData] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);
  const [coaches, setCoaches] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [products, setProducts] = useState({});
  const [appliedPromo, setAppliedPromo] = useState(null);
  const [discount, setDiscount] = useState(0);
  const [discountPercent, setDiscountPercent] = useState(0);
  const [activeSale, setActiveSale] = useState(null);
  const [promoType, setPromoType] = useState(null);
// Assuming you already have priceNoTax, tax, shipping, etc.


  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/";
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
  const token = localStorage.getItem("token");

  let userId = null;
  if (token) {
    try {
      const decoded = jwtDecode(token);
      userId = decoded?.userId;
    } catch (err) {
      console.error("Invalid token:", err);
    }
  }

  const provinceTaxRates = {
    AL: { gst: 0.05, pst: 0, hst: 0 },
    BC: { gst: 0.05, pst: 0.07, hst: 0 },
    MB: { gst: 0.05, pst: 0.07, hst: 0 },
    NB: { gst: 0, pst: 0, hst: 0.15 },
    NL: { gst: 0, pst: 0, hst: 0.15 },
    NT: { gst: 0.05, pst: 0, hst: 0 },
    NS: { gst: 0, pst: 0, hst: 0.15 },
    NU: { gst: 0.05, pst: 0, hst: 0 },
    ON: { gst: 0, pst: 0, hst: 0.13 },
    PE: { gst: 0, pst: 0, hst: 0.15 },
    QC: { gst: 0.05, pst: 0.09975, hst: 0 },
    SK: { gst: 0.05, pst: 0.06, hst: 0 },
    YT: { gst: 0.05, pst: 0, hst: 0 },
  };
    console.log(isFormValid)
const applySiteSale = (price, salePercent = 0) => {
  return salePercent ? price * (1 - salePercent / 100) : price;
};

const getDiscountedPrice = (price, salePercent = 0, promoPercent = 0) => {
  let discounted = price;
  if (salePercent) discounted *= (1 - salePercent / 100);
  if (promoPercent) discounted *= (1 - promoPercent / 100);
  return discounted;
};
console.log(getDiscountedPrice)
    useEffect(() => {
  const fetchActiveSale = async () => {
    try {
      const res = await fetch(`${API_URL}active-sitewide-sale`);
      if (!res.ok) return;
      const data = await res.json();
      setActiveSale(data);
    } catch (err) {
      console.error("Failed to fetch active sale:", err);
    }
  };
  fetchActiveSale();
}, [API_URL]);

    useEffect(() => {
      const fetchCoaches = async () => {
        try {
          const res = await fetch(`${API_URL}reps`);
          const data = await res.json();
          setCoaches(data);
        } catch (err) {
          console.error("Failed to fetch coaches:", err);
        }
      };
    
      fetchCoaches();
    }, [API_URL]);  

    useEffect(() => {
      const userFromSession = JSON.parse(sessionStorage.getItem("user"));
      if (userFromSession && userFromSession.email) {
        setUser(userFromSession);
      } else if (userId) {
        const fetchUser = async () => {
          try {
            const res = await fetch(`${API_URL}account/${userId}`);
            if (res.ok) {
              const data = await res.json();
              setUser(data);
              sessionStorage.setItem("user", JSON.stringify(data));
            } else {
              console.error("Failed to fetch user:", res.status);
            }
          } catch (err) {
            console.error("Error fetching user:", err);
          }
        };
        fetchUser();
      }
    }, [API_URL, userId]);
    

  const fetchCart = useCallback(async () => {
    const storedCart = JSON.parse(sessionStorage.getItem("cart"));

    if (storedCart && storedCart.length > 0) {
      setCartItems(storedCart);
      const productResponses = await Promise.all(
        storedCart.map((item) =>
          fetch(`${API_URL}product/${item.productId}`)
        )
      );
      const productData = await Promise.all(
        productResponses.map((res) => res.json())
      );

      const productsMap = {};
      productData.forEach((product) => {
        productsMap[product._id] = product;
      });
      setProducts(productsMap);
    } else {
      try {
        const res = await fetch(`${API_URL}cart/${userId}`);
        const data = await res.json();
        if (res.ok) {
          setCartItems(data.cart);
          const productResponses = await Promise.all(
            data.cart.map((item) =>
              fetch(`${API_URL}product/${item.productId}`)
            )
          );
          const productData = await Promise.all(
            productResponses.map((res) => res.json())
          );

          const productsMap = {};
          productData.forEach((product) => {
            productsMap[product._id] = product;
          });
          setProducts(productsMap);
        }
      } catch (err) {
        console.error("Failed to fetch cart:", err);
      }
    }
  }, [API_URL, userId]);

  useEffect(() => {
    fetchCart();
  }, [fetchCart]);

  useEffect(() => {
    if (userId) {
      setIsFormValid(true);
    } else {
      const valid =
        (formData.email?.trim() ?? "") !== "" &&
        (formData.coach?.trim() ?? "") !== "";
      setIsFormValid(valid);
    }
  }, [formData, userId, setIsFormValid]);

  const updateQuantity = async (productId, priceType, change) => {
    try {
      const action = change > 0 ? "increment" : "decrement";

      const updatedCartItems = cartItems.map((item) => {
        if (item.productId === productId && item.priceType === priceType) {
          return {
            ...item,
            quantity: Math.max(1, item.quantity + change),
          };
        }
        return item;
      });
      setCartItems(updatedCartItems);

      sessionStorage.setItem("cart", JSON.stringify(updatedCartItems));

      const res = await fetch(`${API_URL}cart/update-quantity`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, productId, priceType, action }),
      });

      if (res.ok) {
        fetchCart();
      } else {
        const errorData = await res.json();
        console.error("Update failed:", errorData.message);
      }
    } catch (err) {
      console.error("Failed to update quantity:", err);
    }
  };

  const removeItem = async (productId, priceType) => {
    try {
      const updatedCartItems = cartItems.filter(
        (item) => !(item.productId === productId && item.priceType === priceType)
      );
      setCartItems(updatedCartItems);

      sessionStorage.setItem("cart", JSON.stringify(updatedCartItems));

      const res = await fetch(`${API_URL}cart/remove-item`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, productId, priceType }),
      });
      if (res.ok) {
        fetchCart();
      }
    } catch (err) {
      console.error("Failed to remove item:", err);
    }
  };

const calculateTotal = () => {
  let subtotal = 0;
  let priceNoTax = 0;
  let itemCount = 0;
  let gst = 0;
  let pst = 0;
  let hst = 0;
  let subtotalBeforePromo = 0;

  const provinceCode = formData.province || user?.province || "null";
  const taxRate = provinceTaxRates[provinceCode] || { gst: 0, pst: 0, hst: 0 };

  cartItems.forEach((item) => {
    const product = products[item.productId];
    if (!product) return;

    const priceTypeKey = (item.priceType || "").toLowerCase();
    let price = item.priceType === "box" ? product.pricing.box : product.pricing.unit;

    // Apply **site-wide sale first**
    if (activeSale?.discountPercent) {
      price = applySiteSale(price, activeSale.discountPercent);
    }
subtotalBeforePromo += price * item.quantity;
    // Apply **promo discount only ONCE**
    if (appliedPromo) {
      price = price * (1 - discountPercent / 100);
    }

    const itemSubtotal = price * item.quantity;

    subtotal += itemSubtotal;
    priceNoTax += itemSubtotal;
    itemCount += item.quantity;

    // Only calculate tax if this item/format is taxable
    const isTaxable = product.taxable && product.taxable[priceTypeKey];
    if (isTaxable) {
      gst += preciseRound(itemSubtotal * (taxRate.gst || 0));
      pst += preciseRound(itemSubtotal * (taxRate.pst || 0));
      hst += preciseRound(itemSubtotal * (taxRate.hst || 0));
    }
  });

  /* const totalTax = gst + pst + hst;
  const shipping = subtotal < 200 ? 19.95 : 0;
  const grandTotal = subtotal + totalTax + shipping; */
  const isFreeShippingPromo =
  appliedPromo === "DANSHIPFIX843" || promoType === "free_shipping";
  const shipping = isFreeShippingPromo
  ? 0
  : (subtotal < 200 ? 19.95 : 0);

// Include shipping in the tax base if shipping is taxable
const shippingTaxable = true; // set to false if you ever want to disable it later 💅

// Recalculate taxes to include shipping if taxable
if (shippingTaxable && shipping > 0) {
  gst += preciseRound(shipping * (taxRate.gst || 0));
  pst += preciseRound(shipping * (taxRate.pst || 0));
  hst += preciseRound(shipping * (taxRate.hst || 0));
}

const totalTax = gst + pst + hst;
const grandTotal = subtotal + shipping + totalTax;
  const toFreeShipping = subtotal < 200 ? (200 - subtotal).toFixed(2) : 0;

  return {
    priceNoTax,
    subtotal,
    subtotalBeforePromo,
    discountedSubtotal: subtotal, // no extra subtraction here!
    gst,
    pst,
    hst,
    tax: totalTax,
    shipping,
    grandTotal,
    toFreeShipping,
    itemCount,
  };
};

  const formatPrice = (price) => {
    const validPrice = isNaN(price) ? 0 : price;
    return validPrice.toFixed(2);
  };

const {
  priceNoTax,
  subtotal,
  subtotalBeforePromo,
  discountedSubtotal,
  gst,
  pst,
  hst,
  tax,
  shipping,
  grandTotal,
  toFreeShipping,
  itemCount,
} = calculateTotal(discount);

console.log(discountedSubtotal)

const discountedTotal = grandTotal - discount;
console.log(discountedTotal)
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let finalValue = value;
    if (name === "coach" && value === "no-coach") {
      const danielle = coaches.find((c) =>
          c.firstName.toLowerCase() === "danielle" && c.lastName.toLowerCase() === "tremblay"
      );
      if (danielle) {
        finalValue = "Does not have a coach"
      }
    }
  
    setFormData((prevData) => ({
      ...prevData,
      [name]: finalValue,
    }));
};

useEffect(() => {
  if (user && coaches.length > 0) {
    setFormData(prev => ({
      ...prev,
      email:    user.email || "",
      coach:    user.assignedCoach || "",
    }));
  }
}, [user, coaches]);

const handleCheckout = async (e) => {
  e.preventDefault();
  setErrors([]);

  if (!user?.email && !formData.email) {
    setErrors(["Email is required"]);
    return;
  }
  if (!formData.coach) {
    setErrors(["Coach is required"]);
    return;
  }
  if (!formData.province) {
    setErrors(["Province is required"]);
    return;
  }

  try {
    // Map cart items and include finalPrice (after sale + promo), productName and taxable
    const cartForBackend = cartItems.map((item) => {
    const product = products[item.productId];
    if (!product) return null;

      const labelsFr = { box: 'Boîte', unit: 'Unité' };
      const stripeLabel = item.priceType === 'box' ? labelsFr.box : labelsFr.unit;

      const basePrice = item.priceType === "box" ? product.pricing.box : product.pricing.unit;
      const salePercent = activeSale?.discountPercent || 0;
      const promoPercent = appliedPromo?.percent ? appliedPromo.percent : 0;
const discounted = (basePrice * (1 - salePercent / 100)) * (1 - promoPercent / 100);
const finalPrice = Number(discounted.toFixed(2));

      // determine taxable for this priceType
      const priceTypeKey = (item.priceType || "").toLowerCase();
      const isTaxable = typeof product.taxable === "object"
      ? Boolean(product.taxable[priceTypeKey])
      : Boolean(product.taxable);
      return {
        productId: item.productId,
        quantity: item.quantity,
        priceType: item.priceType,
        productName: product.name?.[i18n.language] || product.name?.fr || product.name || 'Product',
        stripeLabel,
        finalPrice, // important: exact per-unit discounted price
        taxable: isTaxable,
      };
    }).filter(Boolean);

    // send appliedPromo info too (code + percent) so backend can decrement uses if needed
    const promoPayload = {
  code: appliedPromo,
  percent: discountPercent,
  type: promoType
};

    const response = await fetch(`${API_URL}create-checkout-session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        cartItems: cartForBackend,
        user: { _id: userId, email: user?.email || formData.email },
        coachName: formData.coach || "none",
        province: formData.province,
        appliedPromo: promoPayload,
        shippingOverride: promoType === "free_shipping" ? 0 : null,
      }),
    });

    const data = await response.json();
    if (!data?.id) throw new Error("Stripe session failed");

    const stripe = await stripePromise;
    const { error } = await stripe.redirectToCheckout({ sessionId: data.id });
    if (error) setErrors([error.message]);
  } catch (err) {
    console.error("Checkout error:", err);
    setErrors(["Checkout failed."]);
  }
};
useEffect(() => {
  if (appliedPromo) {
    const newDiscount = (priceNoTax * discountPercent) / 100;
    setDiscount(newDiscount);
  } else {
    setDiscount(0);
  }
}, [appliedPromo, discountPercent, priceNoTax]);
console.log(discountedSubtotal)

return (
  <div>
    <Header />
    <PageLayout>
      <CartColumn>
        <Title>{t("cart.title")}</Title>
        {cartItems.length === 0 ? (
          <p>{t("cart.empty")}</p>
        ) : (
          cartItems.map((item, index) => {
  const product = products[item.productId];
  if (!product) return null;

  // 1️⃣ Base price
  const basePrice = item.priceType === "box" ? product.pricing.box : product.pricing.unit;

  // 2️⃣ Apply site-wide sale ONLY
  const salePrice = activeSale?.discountPercent
    ? applySiteSale(basePrice, activeSale.discountPercent)
    : basePrice;

  return (
    <CartItem key={index}>
    <img src={product.images?.[0]} alt={product.name?.fr} />
    <div>
      <h3>{product.name?.[i18n.language]}</h3>
      <p>{t("cart.priceType")}: {t(`priceType.${item.priceType}`)}</p>

      {/* 💅 Show original + discounted price if sale */}
      <PriceSideBySide>
      {activeSale ? (
        <>
          <OriginalPrice>${formatPrice(item.priceType === 'box' ? product.pricing.box : product.pricing.unit)}</OriginalPrice>
          <DiscountedPrice>
            ${formatPrice(
              (item.priceType === 'box' ? product.pricing.box : product.pricing.unit) *
              (1 - activeSale.discountPercent / 100)
            )}
          </DiscountedPrice>
        </>
      ) : (
        <RegularPrice>
          ${formatPrice(item.priceType === 'box' ? product.pricing.box : product.pricing.unit)}
        </RegularPrice>
      )}
</PriceSideBySide>
      <p>{t("cart.unitPriceWithQty", {price: formatPrice(salePrice * item.quantity), quantity: item.quantity})}</p>

      <QuantityControls>
        <button onClick={() => updateQuantity(item.productId, item.priceType, -1)}>-</button>
        <span>{item.quantity}</span>
        <button onClick={() => updateQuantity(item.productId, item.priceType, 1)}>+</button>
        <RemoveButton onClick={() => removeItem(item.productId, item.priceType)}>
          <Img src={trashcan}/> {t("cart.remove")}
        </RemoveButton>
      </QuantityControls>
    </div>
  </CartItem>
  );
})
        )}
      </CartColumn>
      <CheckoutColumn>
      <EmailCoachSummary>
        <Input name="email"value={formData.email || ""} onChange={handleInputChange} placeholder={t("checkout.email")} type="email" required={!userId}/>
        {errors.length > 0 && (
  <div className="error-messages">
    {errors.map((error, index) => (
      <ErrorMessage key={index}>
        {error}
      </ErrorMessage>
    ))}
  </div>
)}
        <Label htmlFor="coach">{t("checkout.chooseCoach")}</Label>
        <Select name="coach"value={formData.coach || ""} onChange={handleInputChange} required={!userId} disabled={!!userId && !!user.assignedCoach}>
          <option value="" disabled>
            {t("checkout.selectCoach")}
          </option>
          <option value="no-coach">{t("checkout.noCoach")}</option>
          {coaches.map((c) => (
            <option key={c._id} value={`${c.firstName} ${c.lastName}`}>
              {c.firstName} {c.lastName}
            </option>
          ))}
        </Select>
        <Label>
  <P>{t("checkout.province")}</P>
  <Select
  value={formData.province || ""}
  onChange={(e) =>
    setFormData({ ...formData, province: e.target.value })
  }
>
  <option value="">{t("provinces.selectProvince") || "-- Select Province --"}</option>
  {Object.keys(provinceTaxRates).map((code) => (
    <option key={code} value={code}>
      {t(`provinces.${code}`)}
    </option>
  ))}
</Select>
</Label>
          <SummaryCard>
  <h3>{t("summary.title")}</h3>
  <p>{t("summary.items")}: {itemCount}</p>

  {/* Subtotal = sum of all items after sale + promo, before taxes */}
  <SubtotalSum>Subtotal: ${formatPrice(subtotal)}</SubtotalSum>

{appliedPromo && discountPercent === 0 &&(
  <>
    <p style={{ color: "green" }}>
      🎉 Promo <strong>{appliedPromo}</strong> {t("summary.applied")}!
    </p>

    {/* Only show savings if discount > 0 */}
    
  </>
)}
{appliedPromo && discountPercent > 0 && (

      <p style={{ color: "green" }}>
        🎉 Promo <strong>{appliedPromo}</strong> {t("summary.applied")}! {t("summary.saved")}${formatPrice(subtotalBeforePromo - subtotal)}
      </p>
    

)}
  <Promos
    cartSubtotal={subtotal}
   onPromoApplied={(code, percent, type) => {
  setAppliedPromo(code);
  setDiscountPercent(percent);
  setPromoType(type); 
}}
  />
  <p>{t("summary.shipping")}: ${formatPrice(shipping)}</p>

  {gst > 0 && <p>GST: ${formatPrice(gst)}</p>}
  {pst > 0 && <p>PST: ${formatPrice(pst)}</p>}
  {hst > 0 && <p>HST: ${formatPrice(hst)}</p>}

  <p>{t("summary.tax")}: ${formatPrice(tax)}</p>

  <h4 style={{ marginTop: "10px", fontWeight: "700" }}>
    {t("summary.grandTotal")}: ${formatPrice(grandTotal)}
  </h4>
  

  {toFreeShipping > 0 ? (
    <p style={{ color: "red" }}>
      {t("summary.toFreeShipping", { amount: toFreeShipping })}
    </p>
  ) : (
    <p style={{ color: "green" }}>
      {t("summary.freeShippingQualified")}
    </p>
  )}

</SummaryCard>
          <ButtonDiv>
            <CheckoutButton onClick={handleCheckout}>
              {t("checkout.proceed")}
            </CheckoutButton>
            <BackButton onClick={() => navigate("/shop")}>{t("buttons.backToShop")}</BackButton>
          </ButtonDiv>
        </EmailCoachSummary>
        </CheckoutColumn>
    </PageLayout>
    <Footer />
  </div>
);
};

export default CartPage;

// Styled Components

const ButtonDiv = styled.div`
display: flex;
gap: 20px;
`
const PriceSideBySide = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const BackButton = styled.button`
  margin-top: 20px;
  background-color:rgba(148,163,135,1);
  margin-top:  20px;
    color: white;
    border: none;
    padding: 8px 16px;
    font-size: 1.2rem;
    cursor: pointer;
    border-radius: 8px; 
    transition: all 0.3s ease; 
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5);
    &:hover {
      background-color:rgba(217,121,97,1);
      transform: translateY(-2px); 
      box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2); 
    }
    &:active {
      transform: translateY(1px); 
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
    }
`
const OriginalPrice = styled.p`
  text-decoration: line-through;
  color: gray;
  margin: 0;
`;

const DiscountedPrice = styled.p`
  color: rgb(224, 113, 94);
  font-weight: bold;
  margin: 0;
`;

const RegularPrice = styled.p`
  color: black;
  margin: 0;
`;
const SubtotalSum = styled.p`
  text-decoration: underline;
`

const EmailCoachSummary = styled.div`
background: white;
padding: 20px;
border-radius: 8px;
box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5);
`

const Img = styled.img`
max-width: 25px;
max-height: 25px;
padding-right: 10px;

`

const ErrorMessage = styled.p`
  color: red;
  background-color: rgba(54, 54, 54, 0.12);
  text-align: center;
  font-style: italic;
  margin-top: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  padding: 6px 2px;
`;


const Select = styled.select`
display: flex;
  width: 80%;
  margin: 0 auto;
  padding: 10px;
  margin-top: 10px;
  min-width: 300px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 16px;
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5);
`;

const Input = styled.input`
text-align: center;
display: flex;
  width: 80%;
  margin: 0 auto;
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
  min-width: 300px;
  box-shadow: grey -1px 1px 10px;
  border-radius: 6px;
  border: 2px solid grey;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5);
  margin-bottom: 20px;
`;

const Label = styled.label`
text-align: center;
`

const Title = styled.h1`
text-align: center;
`

const PageLayout = styled.div`
font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  display: flex;
  flex-wrap: wrap;
  gap: 50px;
  padding: 40px;
  background: linear-gradient(122deg, rgba(148,163,135,1) 0%, rgba(186,204,171,1) 43%, rgba(246,187,155,1) 83%, rgba(217,121,97,1) 100%);
  min-height: 80vh;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 20px;
  }
`;

const CartColumn = styled.div`
  flex: 2;
`;

const CheckoutColumn = styled.div`
  flex: 1;
  position: sticky;
  top: 80px;
  height: fit-content;
`;

const CheckoutButton = styled.button`
background-color:rgba(148,163,135,1); 
margin-top:  20px;
    color: white;
    border: none;
    padding: 8px 16px;
    font-size: 1.2rem;
    cursor: pointer;
    border-radius: 8px; 
    transition: all 0.3s ease; 
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5);
    &:hover {
      background-color:rgba(217,121,97,1);
      transform: translateY(-2px); 
      box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2); 
    }
    &:active {
      transform: translateY(1px); 
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
    }
`

const CartItem = styled.div`
  display: flex;
  background: white;
  gap: 1rem;
  margin-bottom: 1.5rem;
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5);
  img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 8px;
  }
  div {
    flex-grow: 1;
  }
`;

const QuantityControls = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;

  button {
    background-color:rgba(148,163,135,1); 
    color: white;
    border: none;
    padding: 8px 16px;
    font-size: 1.2rem;
    cursor: pointer;
    border-radius: 8px; 
    transition: all 0.3s ease; 
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5);
    &:hover {
      background-color:rgba(217,121,97,1);
      transform: translateY(-2px); 
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5); 
    }
    &:active {
      transform: translateY(1px); 
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
    }
  }

  span {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
    min-width: 30px;
    text-align: center;
  }
`;


const RemoveButton = styled.button`
  margin-left: auto;
  background: none;
  border: none;
  color: red;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5);
`;

const SummaryCard = styled.div`
  border: 1px solid #ccc;
  padding: 1.5rem;
  border-radius: 10px;
  background: #f9f9f9;
  margin-top: 20px;

  h3 {
    margin-top: 0;
  }

  p {
    margin: 0.3rem 0;
  }

  h4 {
    margin-top: 1rem;
  }
`;

const P = styled.p`

`